// Accent colour used by every visual in this block. Sourced from each brand's
// CSS so Semyla / Spabel / Arkeias can tint the immersive panel without
// touching component code. Definition: brands/<brand>/styles/<brand>.css.
export const LANDING_ACCENT = 'var(--landing-accent)'

export const SYSTEM_VIEWPORT_DELAY_MS = 2000
